import React from 'react'
import { css } from '@emotion/react'
import { colors, font, mq } from 'plume-ui'

type Props = {
  children: string
}

export const FeatureLabel: React.FC<Props> = ({ children }) => {
  return (
    <span
      css={css`
        display: inline-block;
        color: ${colors.textStrong};
        font-size: 20px;
        font-weight: ${font.weight.bold};
        line-height: 1.5;
        letter-spacing: 0.02em;
        ${mq.large} {
          font-size: 24px;
          letter-spacing: 0.01em;
        }
      `}
    >
      {children}
    </span>
  )
}
